<template>
  <span class="px-1">
    <p v-if="showDetails" class="caption my-0">{{ option.id }}</p>
    <v-chip
      v-on="clickable || unselected ? { click: (event) => $emit('click', event) } : {}"
      :outlined="unselected"
      color="primary"
      label
      :class="`${!hasLabel ? 'rai-custom-chip__red-border' : ''} ${draggable ? 'rai-draggable' : ''} my-1`"
      :disabled="disabled"
    >
      <strong>{{ label || $t('global.notranslation') }}</strong>
    </v-chip>
  </span>
</template>

<script>
import naturalOrLogicalLanguageMixin from '@/mixins/natural-or-logical-language-mixin.js';
export default {
  name: 'OptionChip2',

  mixins: [ naturalOrLogicalLanguageMixin ],

  props: {
    option: {
      type: Object,
      required: false,
    },
    unselected: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    clickable: {
      type: Boolean,
      required: false,
      default: false
    },
    draggable: {
      type: Boolean,
      required: false,
      default: false
    },
    showDetails: {
      type: Boolean,
      required: false,
      default: false
    },
  },

  computed: {
    label() {
      var text = ''
      if(this.option) {
        if(this.showLogicalLanguage) {
          text = this.option.prolog
        } else {
          text = this.option.name
        }
      }
      return text
    },

    hasLabel() {
      return !!this.label
    },
  },
};
</script>

<style>
.rai-custom-chip.v-chip .v-chip__content .rai-natural-language{
  position: relative;
  top: 5px;
  word-break: break-word;
}

.rai-custom-chip.v-chip .v-chip__content .rai-logical-language{
  position: relative;
  top: 5px;
  word-break: break-word;
}

.rai-custom-chip.v-chip .v-chip__content {
  display: inline;
  font-weight: bold;
}

.rai-custom-chip.v-chip .v-chip__close {
  float: right;
  right: -14px;
}

.rai-custom-chip__red-border.v-chip {
  box-shadow: 0 0 0 1pt red;
}

.rai-draggable {
  cursor: grab;
}
</style>